import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Sprite = ({
    className,
    name,
    ...spriteAttributes
}) => {
    const classes = classNames(
        'Sprite',
        `sprite-${name}`,
        className
    );

    return (
        <i
            className={classes}
            {...spriteAttributes}
        />
    );
};

Sprite.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired
};

export default Sprite;



// WEBPACK FOOTER //
// ./frontend/src/js/components/sprite/Sprite.jsx